module.exports = __webpack_public_path__ + "img/internal.9ec8c3c.svg";